import * as STD from '@emersya/mpa-std-lib';

import CM                from '@emersya/mpa-components-manager-lib';
import { InputButton }   from '@emersya/mpa-components-lib';

export interface IPlannerFloorTileComponentConfiguration extends InputButton.Configuration {
	SKU : string;
	component : string;
};

export class PlannerFloorTileComponent extends InputButton.Component {
	static override initialize() {
		super.initialize();
	};

	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	get option() {
		// TODO : IS STANDING HARDCODED!!
		if (!app.currentProduct) {
			this.component_throwLibraryError('');
		}
		return app.currentProduct.getPart([ 'floor' ]).
		options.
		find(x => x.reference?.value === (<any> this.component_configuration).SKU);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerFloorTileComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = PlannerFloorTileComponent;
	export type Component = PlannerFloorTileComponent;
	export type Configuration = IPlannerFloorTileComponentConfiguration;
}
;
import manifestXMLSource from './PlannerFloorOptionTile.xml';
import './PlannerFloorOptionTile.scss';

CM.declare({
	id :       'viewer-planner-floor-optionTile',
	type :     PlannerFloorTileComponent,
	manifest : manifestXMLSource
});
